export const IdentificationCard = {
  DPI: 'D',
  DPI_FOREIGN_DOMICILED: 'DFD',
  PASSPORT: 'P',
  BIRTH_CERTIFICATE: 'CN',
  GENERIC: 'DF'
} as const

export type IdentificationCard = (typeof IdentificationCard)[keyof typeof IdentificationCard]

/**
 * Los mismos códigos como TUPLA. Existe porque `z.enum` no acepta `Object.values` —eso es
 * `string[]` y Zod necesita literales—, y porque el validador de la API necesita el mismo
 * conjunto para descartar códigos históricos en vez de castearlos.
 *
 * El `satisfies` es lo que la mantiene honesta: si alguien agrega un tipo al catálogo y se
 * olvida de esta lista, no compila. Sin él, un tipo nuevo viajaría como `null` al contrato.
 */
export const IDENTIFICATION_CARDS = [
  IdentificationCard.DPI,
  IdentificationCard.DPI_FOREIGN_DOMICILED,
  IdentificationCard.PASSPORT,
  IdentificationCard.BIRTH_CERTIFICATE,
  IdentificationCard.GENERIC
] as const satisfies ReadonlyArray<IdentificationCard>

export const IdentificationCardLabel = {
  [IdentificationCard.DPI]: 'DPI',
  [IdentificationCard.DPI_FOREIGN_DOMICILED]: 'DPI Extranjero Domiciliado',
  [IdentificationCard.PASSPORT]: 'Pasaporte',
  [IdentificationCard.BIRTH_CERTIFICATE]: 'Certificado de nacimiento',
  [IdentificationCard.GENERIC]: 'Genérico'
} as const satisfies Record<IdentificationCard, string>
